import gql from 'graphql-tag';

export const GET_STUDENT_ROOMS = gql`
  query student($user_id: Int!) {
    users: v_students(where: { user_id: { _eq: $user_id } }) {
      id: user_id
      user_last_name
      user_first_name
      user_pic
      product_type
      chat_rooms {
        room_name
        id
      }
      lc {
        user_pic
        user_first_name
        user_last_name
      }
      hc {
        user_pic
        user_first_name
        user_last_name
      }
      fa {
        user_pic
        user_first_name
        user_last_name
      }
      admin {
        user_pic
        user_first_name
        user_last_name
      }
    }
  }
`;
